import { render, staticRenderFns } from "./FormBuilderColumn.vue?vue&type=template&id=0b9c29c4&"
import script from "./FormBuilderColumn.vue?vue&type=script&lang=js&"
export * from "./FormBuilderColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports